//https://www.youtube.com/watch?v=u3KlatzB7GM
import {createSlice} from "@reduxjs/toolkit";

//  this showed how to create the reducer
// https://stackoverflow.com/questions/68971771/react-redux-toolkit-action-in-dispatch-returns-err-object-is-not-a-functi

// const initialState = {value: {id: 0, mcode: "", name:"", description: ""}};

export const taxSlice = createSlice({
    name: 'taxSlc',
    initialState: {value: {
            myProductId: null, myGuildId: null, myR2m: null, myCdpId: null,
            updateTaxGrid: false, taxGridState: true}},
    reducers:
        // {
        //     changeTax: (state, action) => {
        //         state.value = action.payload;
        //     },
        // }
{
    changeTax: (state, action) => {
        state.value = {
            ...state.value,  // Keep existing fields
            ...action.payload // Merge new values
        };
    }
}
});

export const {changeTax} = taxSlice.actions;

export default  taxSlice.reducer ;
